export default __webpack_public_path__ + "static/media/henceforth.6671bc3d.png";